import React, { useEffect, useRef, useState } from "react";
import style from "./Jobs.module.css";
import Header from "../../components/Header";
import HeaderMobile from "../../components/HeaderMobile";
import Clients from "../../containers/Clients";
import { JobDashboardImg, JobOrnament1, JobOrnament2 } from "../../assets";
import searchByKeyword from "../../assets/searchByKeyword.png";
import searchByLocation from "../../assets/searchByLocation.png";
import { Link } from "react-router-dom";
import JobPostCard from "../../components/JobPostCard";
import { getJobsList } from "../../api/containersApi";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ClipLoader } from "react-spinners";

export default function Jobs() {

    const isFirstRender = useRef(true);
    const scrollRef = useRef(null);
    const scrollToJobView = () => {
        scrollRef?.current?.scrollIntoView({behavior: "smooth"})
    }

    const [keywordSearch, setKeywordSearch] = useState("");
    const [locationSearch, setLocationSearch] = useState("");
    const [customSearchObject, setCustomSearchObject] = useState({
        "keyword": "",
        "location": "",
        "limit": 21,
        "pageNumber": 1
    });
    const {data, isLoading, isFetching, error, refetch, isPreviousData} = useQuery({
        queryKey: ["jobsList",  JSON.stringify(customSearchObject)],
        queryFn: () => getJobsList({auth_key: localStorage.getItem("sessionToken"), bodyData: customSearchObject}),
        keepPreviousData: true
//        refetchOnWindowFocus: false,
//        keepPreviousData: true,
//        staleTime: 5000,
    });
    // useEffect(() => {
    //     if (isFirstRender.current) {
    //         isFirstRender.current = false; // Mark the first render as done
    //         return; // Skip the effect on initial render
    //     }      
    //     // Your effect logic here
    //     console.log("Passing the check");
    //     scrollToJobView();
    // }, [data]);

    // const mutateJobsList = useMutation({
    //     mutateFn: getJobsList,
    //     onSuccess: (response) => {
    //         setJobList(response?.data?.data?.records)
    //     },
    //     onError: (error) => {
    //         setError(error)
    //     }
    // });
    // mutateJobsList.mutate({auth_key: localStorage.getItem("sessionToken"), bodyData: customSearchObject});

    // initial job list fetches
    // useEffect(() => {
    //     console.log("Inside useEffect", mutateJobsList, localStorage.getItem("sessionToken"), customSearchObject);
    //     mutateJobsList.mutate({auth_key: localStorage.getItem("sessionToken"), bodyData: customSearchObject});
    // }, []);

    return(

        <div className={style.Jobs_container}>

            <HeaderMobile />

            {/* Dashboard */}
            <div className={style.dashboard}>

                <Header />
                
                <div className={style.content_container} data-aos="fade-down" data-aos-duration="1000">
                    <div>
                        <p>Find a job that suits your interest & skills.</p>
                        <p>Explore thousands of jobs across IT, sales, marketing, design, HR, and more — all in one place. Let NuFolks help you land your next big role faster.</p>
                        <button 
                            onClick={(e) => {
                                scrollToJobView();
                            }}
                        >
                            Find Job
                        </button>
                    </div>
                    <img src={JobDashboardImg} alt="Job-Dashboard" />
                </div>

            </div>
            
            {/* Short-cut strip */}
            <div className={style.ShortStrip_container}>
                <img style={{left: 0}} src={JobOrnament1} alt="Ornament1" />
                <img style={{right: 0}} src={JobOrnament2} alt="Ornament2" />
                <p>Still Searching? Submit Your Resume & Stay Connected!</p>
                <Link className={style.Link} to="/upload-your-resume"><button>Upload Resume</button></Link>
            </div>

            {/* Client-logo-slide-show */}
            <div style={{paddingBottom: "2rem", backgroundColor: "white"}}>
                <Clients headingText="Empowering Our Clients with Top Talent" subText="" />
            </div>


            {/* Recent Job Opening */}
            <div ref={scrollRef} className={style.RecentJobOpening_container}>
                <div className={style.headings_container}>
                    <h1>Recent Job Openings</h1>
                    <h2>Browse the latest roles added by top recruiters. New jobs added daily — don’t miss your chance to apply!</h2>
                </div>
                <form className={style.JobSearch_container} onSubmit={(e) => {

                    e.preventDefault();
                    setCustomSearchObject((prev) => {
                        return {
                            ...prev,
                            "pageNumber": 1,
                            "keyword": keywordSearch,
                            "location": locationSearch
                        }
                    });
                    scrollToJobView();
                }}> 

                    <div className={style.input_container}>
                        <label htmlFor="searchByKeyword"><img src={searchByKeyword} alt="Search : " /></label>
                        <input 
                            placeholder="job title, keyword" 
                            type="text" 
                            name="searchByKeyword" 
                            id="searchByKeyword" 
                            value={keywordSearch}
                            onChange={(e) => {
                                setKeywordSearch(e.target.value);
                            }}
                        />
                    </div>
                    
                    <div className={style.input_container}>
                        <label htmlFor="searchByLocation"><img src={searchByLocation} alt="Search : " /></label>
                        <input 
                            placeholder="search by city name" 
                            type="text" 
                            name="searchByLocation" 
                            id="searchByLocation" 
                            value={locationSearch}
                            onChange={(e) => {
                                // setCustomSearchObject((prev) => ({
                                //     ...prev,
                                //     "location": e.target.value
                                // }))
                                setLocationSearch(e.target.value);
                            }}
                        />
                    </div>

                    <button>
                        Find Job
                    </button>
                </form>
                {      
                    <div className={style.JobListing_container}>
                        {       
                            isLoading || isFetching
                                ? 
                            <div style={{textAlign: "center", color: "white", display: "flex", justifyContent: "center", alignItems: "center"}}><ClipLoader color="#FF9900" size={30} speedMultiplier={0.85}/></div> 
                                :
                            (
                                data?.records?.length > 0 
                                    ?                             
                                data?.records?.map((job) => {
                                    return  <JobPostCard to={`job-description/${job?.jobId}`} jobTitle={job?.jobTitle} jobType={job?.jobType} location={job?.location} />
                                })    
                                    :
                                <div style={{textAlign: "center", color: "white", fontSize: "22px", display: "flex", justifyContent: "center", alignItems: "center"}}>Oops! No related jobs found</div> 
                            )
                        }
                    </div>
                }

                {
                    (data?.totalRecord > 21) &&
                    <div data-aos="fade-left" data-aos-offset="-10" className={style.pagination_container}>
                        <button
                            disabled={customSearchObject?.pageNumber === 1 ? true : false}
                            onClick={(e) => {
                                scrollToJobView();
                                // window.setTimeout(() => scrollToJobView(), 200);
                                window.setTimeout(() => {
                                    setCustomSearchObject((prev )=> ({
                                        ...prev,
                                        "pageNumber": prev.pageNumber - 1
                                    }));
                                }, 550);
                            }}
                        >
                            <svg width="46" height="46" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="66" height="66" rx="33" fill={customSearchObject?.pageNumber === 1 ? "gray" : "#FF9900"} />
                                <g clip-path="url(#clip0_1533_352)">
                                <path d="M18.3437 32.1705C18.3441 32.1701 18.3444 32.1697 18.3448 32.1694L24.468 26.0756C24.9268 25.6191 25.6688 25.6208 26.1254 26.0796C26.5819 26.5383 26.5802 27.2803 26.1214 27.7369L22.0103 31.8281H46.8281C47.4754 31.8281 48 32.3528 48 33C48 33.6472 47.4754 34.1719 46.8281 34.1719H22.0103L26.1214 38.2631C26.5801 38.7197 26.5819 39.4617 26.1253 39.9204C25.6687 40.3792 24.9267 40.3808 24.468 39.9244L18.3447 33.8306C18.3444 33.8303 18.3441 33.8299 18.3437 33.8295C17.8847 33.3714 17.8862 32.627 18.3437 32.1705Z" fill="white"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1533_352">
                                <rect width="30" height="30" fill="white" transform="matrix(-1 0 0 1 48 18)"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </button>
                        <button
                            disabled={customSearchObject?.pageNumber === data?.totalpage ? true : false}
                            onClick={(e) => {
                                scrollToJobView();
                                // window.setTimeout(() => scrollToJobView(), 200);
                                window.setTimeout(() => {
                                    setCustomSearchObject(prev=>({
                                        ...prev,
                                        "pageNumber": prev.pageNumber + 1
                                    }));
                                }, 550)
                            }}                
                        >
                            <svg width="46" height="46" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="66" height="66" rx="33" fill={customSearchObject?.pageNumber === data?.totalpage ? "gray" : "#FF9900"} />
                                <g clip-path="url(#clip0_1533_357)">
                                <path d="M47.6563 32.1705C47.6559 32.1701 47.6556 32.1697 47.6552 32.1694L41.532 26.0756C41.0732 25.6191 40.3312 25.6208 39.8746 26.0796C39.4181 26.5383 39.4198 27.2803 39.8786 27.7369L43.9897 31.8281H19.1719C18.5246 31.8281 18 32.3528 18 33C18 33.6472 18.5246 34.1719 19.1719 34.1719H43.9897L39.8786 38.2631C39.4199 38.7197 39.4181 39.4617 39.8747 39.9204C40.3313 40.3792 41.0733 40.3808 41.532 39.9244L47.6553 33.8306C47.6556 33.8303 47.6559 33.8299 47.6563 33.8295C48.1153 33.3714 48.1138 32.627 47.6563 32.1705Z" fill="white"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1533_357">
                                <rect width="30" height="30" fill="white" transform="translate(18 18)"/>
                                </clipPath>
                            </defs>
                            </svg>
                        </button>
                    </div>
                }

            </div>
            <div className={style.ShortStrip_container_2}>
                <img style={{left: "-20px"}} src={JobOrnament1} alt="Ornament1" />
                <img style={{right: "-28px"}} src={JobOrnament2} alt="Ornament2" />
                <p className={style.para_1}>Didn’t Find the Right Fit? Let Us Connect You to It.</p>
                <p className={style.para_2}>Our recruiters are always working behind the scenes to bring you the best-fit jobs. Share your profile to stay updated.</p>
                <Link className={style.Link} to="/upload-your-resume"><button>Upload Resume</button></Link>
            </div>

        </div>
    )
}